module.exports = __webpack_public_path__ + "static/media/LEND-logo.4a81c589.png";